var map = {
	"./abb-color.svg": 1770,
	"./afb-color.svg": 1771,
	"./afb.svg": 1772,
	"./agro-color.svg": 1773,
	"./alb-color.svg": 1774,
	"./alb.svg": 1775,
	"./amb-color.svg": 1776,
	"./amb.svg": 1777,
	"./bbbaidja-color.svg": 1778,
	"./bbbaidjaxxx-color.svg": 1779,
	"./bdinidjaxxx-color.svg": 1780,
	"./bimb-color.svg": 1781,
	"./bimb.svg": 1782,
	"./bkr-color.svg": 1783,
	"./bkr.svg": 1784,
	"./bmriidja-color.svg": 1785,
	"./bniaidja-color.svg": 1786,
	"./bninidja-color.svg": 1787,
	"./bninidjaxxx-color.svg": 1788,
	"./boc-color.svg": 1789,
	"./bpay-color.svg": 1790,
	"./brinidja002-color.svg": 1791,
	"./bsmdidjaxxx-color.svg": 1792,
	"./bsn-color.svg": 1793,
	"./bsn.svg": 1794,
	"./btanidjaxxx-color.svg": 1795,
	"./cenaidja-color.svg": 1796,
	"./cenaidjaxxx-color.svg": 1797,
	"./cimb-color.svg": 1798,
	"./cimb.svg": 1799,
	"./citi-color.svg": 1800,
	"./citi.svg": 1801,
	"./default-bank-icon-color.png": 1802,
	"./default-bank-icon.png": 1803,
	"./gxbank-color.svg": 1804,
	"./hlb-color.svg": 1805,
	"./hlb.svg": 1806,
	"./hsbc-color.svg": 1807,
	"./hsbc.svg": 1808,
	"./ibbkidjaxxx-color.svg": 1809,
	"./kfh-color.svg": 1810,
	"./kwh-color.svg": 1811,
	"./kwh.svg": 1812,
	"./mbb-color.svg": 1813,
	"./mbb.svg": 1814,
	"./muamalat-color.svg": 1815,
	"./nispidjaxxx-color.svg": 1816,
	"./ocbc-color.svg": 1817,
	"./ocbc.svg": 1818,
	"./pbb-color.svg": 1819,
	"./pbb.svg": 1820,
	"./pinbidja-color.svg": 1821,
	"./raykat-color.svg": 1822,
	"./rhb-b.svg": 1823,
	"./rhb-color-b.svg": 1824,
	"./rhb-color.svg": 1825,
	"./rhb.svg": 1826,
	"./scb-color.svg": 1827,
	"./scb.svg": 1828,
	"./tng-color.svg": 1829,
	"./uob-color.svg": 1830,
	"./uob.svg": 1831
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;